"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _history = require("../../utils/history");

var _urls = require("../../utils/urls");

var NoAccessError = function NoAccessError(_ref) {
  var use = _ref.use;
  var getI18nKey = (0, _react.useCallback)(function (key) {
    return "appMarketplace.error." + (use === 'preview' ? 'noPreviewAccess' : 'noAccess') + "." + key;
  }, [use]);
  var handleButtonClick = (0, _react.useCallback)(function () {
    if (use === 'preview') {
      window.location.href = (0, _urls.getLoginUrl)();
    } else {
      (0, _history.push)('/');
    }
  }, [use]);
  return _react.default.createElement(_UIErrorMessage.default, {
    illustration: "keys",
    title: (0, _unescapedText.default)(getI18nKey('title'))
  }, _react.default.createElement(_UIButton.default, {
    className: "m-top-4",
    use: "tertiary",
    onClick: handleButtonClick
  }, _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey('button')
  })));
};

NoAccessError.propTypes = {
  use: _propTypes.default.oneOf(['default', 'preview'])
};
NoAccessError.defaultProps = {
  use: 'default'
};
var _default = NoAccessError;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/error/NoAccessError.js
// module id = 768
// module chunks = 209 210 211 212